<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">옵션 상품 추가하기</p>

    <v-sheet class="mt-2 px-4">
      <!-- 코드 -->
      <v-text-field class="rounded-10" label="코드" dense outlined v-model.trim="create.code" :counter="20" :rules="[rules.required, rules.codeLength]"></v-text-field>

      <!-- 가격 -->
      <v-text-field class="rounded-10" label="가격 (원)" dense outlined v-model.number="create.price" type="number" :rules="[rules.required, rules.priceValid]" @input="validatePrice"></v-text-field>

      <!-- 제목 섹션 -->
      <div class="font-weight-bold text-h6 ml-4 mt-4 mb-2">제목</div>

      <!-- 한글 제목 -->
      <v-text-field class="rounded-10" label="제목 (한글)" dense outlined v-model.trim="create.title.kr" :counter="30" :rules="[rules.required, rules.titleLength]"></v-text-field>

      <!-- 영어 제목 -->
      <v-text-field class="rounded-10" label="제목 (영어)" dense outlined v-model.trim="create.title.en" :counter="30" :rules="[rules.titleLength]"></v-text-field>

      <!-- 일본어 제목 -->
      <v-text-field class="rounded-10" label="제목 (일본어)" dense outlined v-model.trim="create.title.jp" :counter="30" :rules="[rules.titleLength]"></v-text-field>

      <!-- 설명 섹션 -->
      <div class="font-weight-bold text-h6 ml-4 mt-4 mb-2">설명</div>

      <!-- 한글 설명 -->
      <v-textarea class="rounded-10" label="부제목 (한글)" dense outlined v-model.trim="create.subTitle.kr" :counter="200" :rules="[rules.required, rules.subTitleLength]" rows="3"></v-textarea>

      <!-- 영어 설명 -->
      <v-textarea class="rounded-10" label="부제목 (영어)" dense outlined v-model.trim="create.subTitle.en" :counter="200" :rules="[rules.subTitleLength]" rows="3"></v-textarea>

      <!-- 일본어 설명 -->
      <v-textarea class="rounded-10" label="부제목 (일본어)" dense outlined v-model.trim="create.subTitle.jp" :counter="200" :rules="[rules.subTitleLength]" rows="3"></v-textarea>

      <!-- 이벤트 페이지 선택 섹션 -->
      <div class="font-weight-bold text-h6 ml-4 mt-4 mb-2">상세 설명 페이지</div>

      <!-- 이벤트 페이지 선택 다이얼로그 -->
      <EventPageSelector 
        v-model="create.descriptionCode"
        @select="onEventPageSelected"
        @clear="onEventPageCleared"
      />
    </v-sheet>

    <!-- 버튼 -->
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="createSubmit()">
        <v-icon small left>mdi-database-plus-outline</v-icon>
        추가하기
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>

<script>
import optionProductService from "@/api/optionProductService"
import EventPageSelector from "./EventPageSelector"

export default {
  components: {
    EventPageSelector,
  },
  data: () => ({
    create: {
      code: "",
      title: {
        kr: "",
        en: "",
        jp: "",
      },
      subTitle: {
        kr: "",
        en: "",
        jp: "",
      },
      price: 0,
      descriptionCode: null,
    },

    // Validation rules
    rules: {
      required: (value) => !!value || "필수 입력 항목입니다.",
      codeLength: (value) => (value && value.length <= 20) || "코드는 20자 이내여야 합니다.",
      titleLength: (value) => !value || value.length <= 30 || "제목은 30자 이내여야 합니다.",
      subTitleLength: (value) => !value || value.length <= 200 || "설명은 200자 이내여야 합니다.",
      priceValid: (value) => value >= 0 || "가격은 0원 이상이어야 합니다.",
    },

    // Selected event page info
    selectedEventPage: null,
  }),

  methods: {
    // 이벤트 페이지 선택 핸들러
    onEventPageSelected(page) {
      this.selectedEventPage = page
      console.log("선택된 이벤트 페이지:", page)
    },

    // 이벤트 페이지 선택 해제 핸들러
    onEventPageCleared() {
      this.selectedEventPage = null
    },

    // Validate price input
    validatePrice() {
      if (this.create.price < 0) {
        this.create.price = 0
      }
    },

    // Submit form
    createSubmit: _.debounce(async function () {
      // Validate required fields
      if (!this.create.code) {
        alert("코드를 입력해주세요")
        return
      }

      if (!this.create.title.kr) {
        alert("한글 제목을 입력해주세요")
        return
      }

      if (!this.create.subTitle.kr) {
        alert("한글 설명을 입력해주세요")
        return
      }

      if (this.create.price < 0) {
        alert("유효한 가격을 입력해주세요")
        return
      }

      // Check code length
      if (this.create.code.length > 20) {
        alert("코드는 20자 이내여야 합니다")
        return
      }

      // Check title lengths
      if (this.create.title.kr.length > 30 || (this.create.title.en && this.create.title.en.length > 30) || (this.create.title.jp && this.create.title.jp.length > 30)) {
        alert("제목은 30자 이내여야 합니다")
        return
      }

      // Check subtitle lengths
      if (this.create.subTitle.kr.length > 200 || (this.create.subTitle.en && this.create.subTitle.en.length > 200) || (this.create.subTitle.jp && this.create.subTitle.jp.length > 200)) {
        alert("설명은 200자 이내여야 합니다")
        return
      }

      try {
        // Check for duplicate code
        const duplicateCheck = await optionProductService.checkDuplicateCode(this.create.code)
        if (duplicateCheck.isDuplicate) {
          alert("이미 사용중인 코드입니다")
          return
        }

        // Submit to API
        await optionProductService.createOptionProduct({
          code: this.create.code,
          title: JSON.stringify(this.create.title),
          subTitle: JSON.stringify(this.create.subTitle),
          price: Number(this.create.price),
          descriptionCode: this.create.descriptionCode || null,
        })

        alert("정상적으로 등록되었습니다.")
        this.$emit("close")
      } catch (error) {
        console.error("옵션 상품 등록 오류:", error)
        alert(error.message || "등록 중 오류가 발생했습니다")
      }
    }, 500),
  },
}
</script>

<style scoped></style>
